export function dateDifference(updatedOn){
    const date1 = new Date(updatedOn);
    var currentTimeInMilliseconds = Date.now();
    const date2 = new Date(currentTimeInMilliseconds);

    let noOfDays = getDifferenceInDays(date1, date2);
    let noOfHours = getDifferenceInHours(date1, date2);
    let noOfMins = getDifferenceInMinutes(date1, date2);
    let noOfSecs = getDifferenceInSeconds(date1, date2);

    if (noOfDays > 6) {
      const date = new Date(date1);
      return <span>{date.toLocaleDateString()}</span>;
    } else if (noOfDays >= 2 && noOfDays <= 6) {
      return <span>{Math.floor(noOfDays) + " days ago"}</span>;
    } else if (noOfDays >= 1 && noOfDays < 2) {
      return <span>{Math.floor(noOfDays) + " day ago"}</span>;
    } else if (noOfHours > 23 && noOfHours <= 24) {
      return <span>{"1 day ago"}</span>;
    } else if (noOfHours >= 2 && noOfHours <= 23) {
      return <span>{Math.floor(noOfHours) + " hours ago"}</span>;
    } else if (noOfHours >= 1 && noOfHours <= 2) {
      return <span>{Math.floor(noOfHours) + " hour ago"}</span>;
    } else if (noOfMins >= 2 && noOfHours <= 59) {
      return <span>{Math.floor(noOfMins) + " minutes ago"}</span>;
    } else if (noOfMins >= 1 && noOfHours < 2) {
      return <span>{Math.floor(noOfMins) + " minute ago"}</span>;
    } else if (noOfSecs >= 1 && noOfSecs <= 59) {
      return <span>{"Few seconds ago"}</span>;
    }
  };
  function getDifferenceInDays(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / (1000 * 60 * 60 * 24);
  }

  function getDifferenceInHours(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / (1000 * 60 * 60);
  }

  function getDifferenceInMinutes(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / (1000 * 60);
  }

  function getDifferenceInSeconds(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / 1000;
  }